export default __webpack_public_path__ + "static/media/generic_error.309cbbb7.svg";